import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import ShipIcon from "../components/Icons/ShipIcon";
import AirPlaneIcon from "../components/Icons/AirPlaneIcon";
import { SimpleBookingFormType } from "./Logistics/SimpleBooking";
import Dropdown from "./DropDown";
import InputWithLabel from "./InputWithLabel";

const transportationByOptions = [
  { label: "Full container load FCL", value: "FCL" },
  { label: "Less container load LCL", value: "LCL" },
  { label: "BULK", value: "BULK" },
];

const ShippingDropdown = () => {
  const { register, watch, trigger } = useFormContext<SimpleBookingFormType>();

  const freight_type = watch("freight_type");

  useEffect(() => {
    if (freight_type === "ocean") {
      trigger("transportation_by");
    } else if (freight_type === "air") {
      trigger(["freight_type", "weight"]);
    }
  }, [freight_type, trigger]);

  return (
    <div className="w-full bg-white border p-4 rounded-lg shadow-md flex flex-col gap-4 z-50">
      {/* Freight Type */}
      <div>
        <label className="block text-[#344054] text-sm font-medium">
          Freight Type
        </label>
        <fieldset className="flex items-center gap-4">
          <label
            className={`flex items-center gap-2 px-4 py-2 rounded-2xl border shadow-sm transition cursor-pointer ${
              freight_type === "ocean"
                ? "bg-blue-600 text-white"
                : "bg-white text-black"
            }`}
          >
            <input
              type="radio"
              value="ocean"
              {...register("freight_type")}
              className="sr-only"
            />
            <ShipIcon />
            Ocean
          </label>

          <label
            className={`flex items-center gap-2 px-4 py-2 rounded-2xl border shadow-sm transition cursor-pointer ${
              freight_type === "air"
                ? "bg-blue-600 text-white"
                : "bg-white text-black"
            }`}
          >
            <input
              type="radio"
              value="air"
              {...register("freight_type")}
              className="sr-only"
            />
            <AirPlaneIcon />
            Air
          </label>
        </fieldset>
      </div>

      {/* Transportation By Dropdown */}
      {freight_type === "ocean" && (
        <Dropdown
          label="Transportation By"
          placeholder="Select a option"
          options={transportationByOptions}
          {...register("transportation_by", {
            required: true,
          })}
        />
      )}

      <InputWithLabel
        label="Weight (Kgs)"
        placeholder="Enter weight"
        type="text"
        {...register("weight", {
          required: true,
        })}
      />
    </div>
  );
};

export default ShippingDropdown;
